import { AxiosResponse } from 'axios';
import { Result } from '../models/common/resultResponse';
import { CompanyPreferencesResponse } from '../models/response';
import { ICompanyPreferenceApi } from './base';
import { api } from './base/api';

const baseRoute: string = 'CompanyPreference';

export class CompanyPreferenceApi extends ICompanyPreferenceApi {
  GetCompanyPreferencesByLoggedUser(): Promise<AxiosResponse<Result<CompanyPreferencesResponse>>> {
        return api.get(`${baseRoute}/GetCompanyPreferencesByLoggedUser`);
  }

}

